import { css } from "@emotion/react"
import { GlobalToken } from "antd"

export const displayFlexColumn = css`
	display: flex;
	flex-direction: column;
`

export const displayFlexCentered = css`
	display: flex;
	justify-content: center;
	align-items: center;
`

export const heightWidth100 = css`
	height: 100%;
	width: 100%;
`

export const borderBackgroundNone = css`
	background: none;
	border: 0;
`

export const borderBackgroundFocusNone = css`
	background: none;
	border: 0;

	&:focus {
		outline: 0;
	}
`

export const pageContentCss = (theme: GlobalToken) => css`
	padding: ${theme?.padding}px;
	background: ${theme.colorBgContainer};

	.gutter-row {
		margin-bottom: ${theme?.padding}px;
	}
	.renewal-note-container {
		.profile-card-component {
			&.expired-note {
				background-color: ${theme.colorErrorBgHover};
			}
			&.expiring-note {
				background-color: ${theme.colorWarningBgHover};
			}
			.note-content {
				padding: 0.5rem 1rem;
				.error-icon {
					color: ${theme.colorWarning};
					font-size: ${theme.fontSizeXL}px;
					margin-right: ${theme.marginSM}px;
				}
			}
		}
	}

	.expired-note-container {
		.profile-card-component {
			background-color: ${theme.colorErrorBgHover};
			.note-content {
				padding: 1rem;
				.error-icon {
					color: ${theme.colorError};
					font-size: ${theme.fontSizeXL}px;
					margin-right: ${theme.marginSM}px;
				}
			}
		}
	}
`

export const modalFooterButtonGroupStyles = (theme: GlobalToken) => css`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	.ant-tag {
		white-space: normal;
		text-align: center;
		display: flex;
		align-items: center;
	}
	.confirm-btn {
		&:disabled {
			opacity: 0.5;
		}
	}
`

export const baseModalStyles = (theme: GlobalToken) => css`
	.ant-modal-content {
		border-radius: 10px !important;
		padding: 0;
	}

	.ant-modal-header {
		border-bottom: none;

		.ant-modal-title {
			font-size: ${theme?.fontSizeLG}px;
		}
	}

	.ant-modal-footer {
		border-top: none;
	}
`

export const commonCardCss = css`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0.5rem 1rem;
	border-radius: 0.5rem;
`

export const absoluteCenter = css`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`

export const bottomSticky = css`
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
`

export const radioGroupCss = (theme: GlobalToken) => css`
	.ant-radio-group {
		margin-bottom: 0 !important;
	}
	.ant-radio-button-wrapper {
		border-width: 1px;
		color: #444;
	}

	.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
		border-color: ${theme.colorPrimary};
	}

	.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
		background: ${theme.colorPrimary} !important;
	}

	.ant-radio-button-wrapper-checked {
		border-color: ${theme.colorPrimary};
		color: ${theme.colorWhite};
		background: ${theme.colorPrimary} !important;
		font-weight: 700;

		&:hover {
			border-color: ${theme.colorPrimary};
		}
	}

	.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
		box-shadow: -1px 0 0 0 ${theme.colorPrimary};

		&:first-of-type {
			border-color: ${theme.colorPrimary};
		}
	}

	.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
		color: ${theme.colorPrimaryBg};
	}
`

export const mUiSwitchCss = (theme: GlobalToken) => css`
	.MuiSwitch-switchBase {
		color: ${theme.colorPrimary};

		.MuiSwitch-track {
			background: ${theme.colorBgLayout} !important;
		}

		&.Mui-checked {
			color: ${theme.colorPrimary};

			& + .MuiSwitch-track {
				background: ${theme.colorPrimaryHover} !important;
			}
		}
	}
`

export const neutralBgColor = "rgba(187, 207, 245, 0.25)"

export const rounderBorderPrimary = (theme: GlobalToken) => css`
	border: 1px solid ${theme.colorPrimary};
	border-radius: ${theme.borderRadius}px;
`
